module.exports = __webpack_public_path__ + "img/7.04379609.png";